module.exports = __webpack_public_path__ + "c882e084265bd0d78ddc206d55def963.jpg";